/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';

import { navigate } from 'gatsby';

import { CRAFT_SECTIONS } from '../../const/data.const';
import { ROUTES } from '../../const/routes.const';
import { IAppContext } from '../../context/app/app.types';
import { useAppContext } from '../../hooks/context/appContext.hook';
import { useGridData } from '../../hooks/data/grid.hook';
import useResize from '../../hooks/resize.hook';
import * as grid from '../../scripts/grid';
import { IGridContentLink } from '../../types/grid.types';

export const Grid: React.FC = () => {
	const { isResizing } = useResize();
	const { highlights, extended } = useGridData();
	const { isGridInitialised, setIsGridInitialised, setIsAnimating }: IAppContext =
		useAppContext();

	const handleTransitionComplete = (): void => {
		setIsAnimating(false);
	};

	const handleClick = (link: IGridContentLink) => {
		// NavigateGrid
		if (link?.external) {
			window.open(link.external, '_blank', 'noopener,noreferrer');
			return;
		}

		if (link?.sectionHandle === CRAFT_SECTIONS.COLLECTIONS) {
			navigate(`/${ROUTES.COLLECTIONS}/${link.internal}`, {
				state: { isGridImage: true },
			});
		}

		if (link?.sectionHandle === CRAFT_SECTIONS.DEFAULT) {
			navigate(`${link.internal}`);
		}
	};

	useEffect(() => {
		if (!isGridInitialised) {
			grid.init(handleClick, handleTransitionComplete);

			grid.loadContent(highlights, extended);
			setIsGridInitialised(true);

			return;
		}

		grid.reinit();

		return () => {
			grid.setMounted(false);
		};
	}, []);

	useEffect(() => {
		if (isResizing) {
			grid.handleResize();
		}
	}, [isResizing]);

	return <canvas data-scroll-section className="c-canvas js-canvas"></canvas>;
};
